import ConsultantSearch from "util/ConsultantSearch";

export default function handleConsultantSearchBlocks() {
    let $consultants = $('.js-consultants');

    $consultants.each(function () {
        new ConsultantSearch($(this));
    });
}
